<template>
    <div>
        <h1>Dashboard</h1>

        <h2>DropdownSlider</h2>

        <DropdownSlider v-model="DropdownSlider.value" />
        <div>
          <span>DropdownSlider.value:</span>
          <code>{{ DropdownSlider.value }}</code>
        </div>

        <h2>EventsItem</h2>
        <template v-for="item in events">
          <EventsItem :key="item.id" :value="item"></EventsItem>
        </template>

        <h2>PeriodSelector</h2>
        <PeriodSelector
          v-model="PeriodSelector.value"
          :dimension="PeriodSelector.dimension"
          @dimensionChanged="PeriodSelector.dimension=$event">

        </PeriodSelector>
        <hr class="adm-hr">

        <h2>DatePicker</h2>
        <iv-date-picker type="month"></iv-date-picker>
        <iv-date-picker type="month"></iv-date-picker>
        <hr class="adm-hr">

        <ListedOpinionItem :value="item">
          <div>
            <div style="margin-bottom: 10px;">
              <iv-button v-rbac-allow="['publicSentiment','edit']" size='small' :type="item.is_confirm == '1' ? 'ghost' : 'primary' ">收录</iv-button>
            </div>
            <div>
              <iv-button v-rbac-allow="['publicSentiment','edit']" size='small' type="primary" ghost>排除</iv-button>
            </div>
          </div>
        </ListedOpinionItem>
        <iv-checkbox-group v-model="checkedlist">
          <ListedOpinionItem :value="item" type="audit">
            <iv-checkbox slot="checkbox" :label="item.id"><span></span></iv-checkbox>
            <span slot="buttons">
              <iv-button v-rbac-allow="['publicSentiment','edit']" size='small' type="primary" ghost>修改</iv-button>
            </span>
          </ListedOpinionItem>
        </iv-checkbox-group>
        <h2>RichSearchInput</h2>
        <RichSearchInput
          v-model="conditions.company"
          :options="companySetting.options"
          :input="companySetting.input"
          :pagination="companySetting.pagination"
          :loading="companySetting.loading"
          @input="onInput"
          @pageChanged="onPageChanged"
          />
        <h2>FilterBar_x2.1</h2>
        <FilterBar
          :value="conditions"
          :condition="options.filter_rules"
          :builder="builder">
        </FilterBar>
        <h2>polling</h2>
        <div>
          <iv-button @click="run()">run()</iv-button>
          <iv-button @click="stop()">stop()</iv-button>
          <iv-button @click="pause('test')">pause('test')</iv-button>
          <iv-button @click="pause('abc')">pause('abc')</iv-button>
          <div style="height: 500px; overflow-y:auto">
            <div
              v-for="(log,index) in logs"
              :key="index">
              {{ log }}
            </div>
          </div>
        </div>
    </div>
</template>
<script>
import ListedOpinionItem from "@/components/ListedOpinionItem.vue"
import ListedSentimentModel from "@/models/ListedSentimentModel"
import FilterBar from '@/components/FilterBar_x2.1'
// import RichSearchInput from '@/components/RichSearchInput'
import EventsItem from "@/components/EventsItem.vue";
import DropdownSlider from "@/components/DropdownSlider.vue";

import {
  default as PeriodSelector,
  DIMENSION_TYPE_OF_MONTH,
  DIMENSION_TYPE_OF_WEEK
} from '@/components/PeriodSelector';

import contact from "@/utils/contact";
import LoaderMixin from "@/mixins/Loader.mixin";
import CompanyModel from "@/models/CompanyModel";
import ModelMixin from "@/mixins/Model.mixin";

import polling from "@/utils/polling";

const options = {
  // year:[],
  industry: [],
  companys: [],
  secondTargets: [],
  emptySecondTargets: [],
  targetType: [
    { id: '0', name: '定量' },
    { id: '1', name: '定性' }
  ],
  inputTab: [
    { id: '0', name: '全部' },
    { id: '1', name: '已完成' },
    { id: '2', name: '未完成' }
  ],
  reportTab: [
    { id: '0', name: '缺年报' },
    { id: '1', name: '缺社报' },
    { id: '2', name: '缺年/社报' }
  ],
  audit: [
    { id: '0', name: '' },
    { id: '1', name: '待审核' },
    { id: '2', name: '不通过' },
    { id: '3', name: '通过' }
  ]
}
const filter_rules = [
  { name: 'industryId', type: 'Select', options: [], title: '行业', default: '', placeholder: '行业', style: { width: '150px' } },
  { name: 'stockCode', type: 'Select', options: [], title: '公司', default: '', placeholder: '公司', filterable: true, clearable: true, style: { width: '150px' } },
  { name: 'year', type: 'Select', options: [], title: '年份', default: '', placeholder: '年份' },
  { name: 'inputStatus', type: 'Select', options: options.inputTab, title: '录入情况', default: '0', placeholder: '录入情况', style: { width: '120px' } },
  { name: 'reportStatus', type: 'Select', options: options.reportTab, title: '报告情况', default: '', placeholder: '报告情况', clearable: true, style: { width: '120px' } },
]

const COMPANY = CompanyModel.ModelName;

export default {
  mixins: [
    LoaderMixin([COMPANY]),
    ModelMixin({
      contact,
      models: [CompanyModel]
    })
  ],
  data(){
    return {
      DropdownSlider:{
        value: ""
      },
      events:[
        {
            "id": 17459,
            "sentimentType": 0,
            "oid": "e463d9d39ead4ae3b7e55f41cb47ef75",
            "companyInfo": {
                "abbreviation": "平安银行",
                "companyName": "平安银行股份有限公司",
                "industryId": 1,
                "industry": "金融业"
            },
            "stockCode": "000001",
            "holdingRatio": 0.0,
            "unitName": "平安银行股份有限公司福州分行;陈敏",
            "category": "银行保险",
            "punishCategory": "罚款",
            "punishmentNumber": "闽金罚决字〔2023〕32号",
            "crawlTime": "2024-01-07 09:07:41",
            "punishDate": "2023-12-29",
            "institutionalFines": 2700000.0,
            "personalFines": 0.0,
            "confiscateIllegalGains": 0.0,
            "basisOfPunishment": "《中华人民共和国银行业监督管理法》第二十一条、第四十六条、第四十八条及相关审慎经营规则",
            "title": "青悦--闽金罚决字〔2023〕32号",
            "content": "",
            "illegalFact": "一、房地产开发贷款内控管理不到位; 二、贷后管理不到位，未尽职监控贴现资金流向; 三、个人经营贷款贷前调查不尽职，贷后管理不到位; 四、流动资金贷款贷前调查不尽职，贷后管理不到位; 五、置换贷款贷前调查不尽职; 六、个人装修贷款制度、机制不健全，内部监督检查不到位; 七、办理银行承兑汇票业务未按规定对发票原件加盖专用章",
            "punishContent": "一、对平安银行股份有限公司福州分行合计处以270万元罚款;二、对陈敏给予警告",
            "punishmentAuthority": "国家金融监督管理总局福建监管局",
            "illegalActType": "",
            "blockedDays": 0.0,
            "originUrl": "https://www.cbirc.gov.cn/cn/view/pages/ItemDetail.html?docId=1145956&itemId=4114",
            "thirdTargetNum": "G_9_5",
            "score": 4.0,
            "audit": 1,
            "comment": "",
            "additionRatio": 1.0,
            "firstTargetNum": "G",
            "firstTargetName": "治理",
            "secondTargetNum": "G_9",
            "secondTargetName": "分子公司内控与合规",
            "thirdTargetName": "银行管理不到位",
            "dimensionInfo": [
                {
                    "dimensionId": 6,
                    "dimensionScore": 4.0,
                    "dimension": "公司处罚",
                    "dimensionWeight": 5.0,
                    "dimensionRuleExplain": "1、警告/点名  1分；\n2、罚款≤50万  2分；\n3、罚款50～100万元（含）  3分；\n4、罚款100～300万元（含）  4分；\n5、罚款>300万元  5分；",
                    "dimensionRatio": 0.5
                },
                {
                    "dimensionId": 7,
                    "dimensionScore": 0,
                    "dimension": "人员(及其他)处罚",
                    "dimensionWeight": 7.0,
                    "dimensionRuleExplain": "1、个人罚款≤100万  2分；\n2、个人罚款＞100万  3分；\n3、禁止从业  4分；\n4、吊销资质  5分；\n5、行政拘留  6分；\n6、移送涉罪  7分；",
                    "dimensionRatio": 0.5
                }
            ]
        }
      ],
      DIMENSION_TYPE_OF_MONTH,
      DIMENSION_TYPE_OF_WEEK,
      PeriodSelector: {
        value: [],
        dimension: DIMENSION_TYPE_OF_MONTH
      },

      logs: [],
      checkedlist: [],
      item: {
        ...ListedSentimentModel.schema.default(),
        id: 111,
        title: "辞职3年后 浦发银行原副行长被查 曾因成都分行案被罚30万元",
        companyInfo: {
          abbreviation: "浦发银行",
          companyName: ""
        },
        postTime: new Date,
        source: "网易新闻",
        keywords: "负增长",
        negativeSection: "2020年度该公司营业收入出现负增长情况，可以显示更多的情况。现在最多可能显示超过三行的程度。到这里内容已经到三行好。超出三行时，显示...省略号在最后。",
        score: 89,
        is_confirm: 0,
        audit: 2,
        sentiment_new: "负面",
        secondTargetName: "公司管理",
        thirdTargetName: "发生管理漏洞被监管处罚",
        comment: `公司影响 分数太高
媒体报道 分数太高
利益相关方伤害 分数太高`,
        dimensionInfo: [
          {
            dimensionId:1,
            dimension: "公司影响",
            dimensionScore: 15,
            dimensionWeight: 0,
            dimensionRuleExplain: ""
          },
          {
            dimensionId:2,
            dimension: "信披违规",
            dimensionScore: 20,
            dimensionWeight: 0,
            dimensionRuleExplain: ""
          },
          {
            dimensionId:3,
            dimension: "利益相关方伤害",
            dimensionScore: 11,
            dimensionWeight: 0,
            dimensionRuleExplain: ""
          },
          {
            dimensionId:4,
            dimension: "财务影响",
            dimensionScore: 13,
            dimensionWeight: 0,
            dimensionRuleExplain: ""
          },
          {
            dimensionId:5,
            dimension: "监管处罚",
            dimensionScore: 8,
            dimensionWeight: 0,
            dimensionRuleExplain: ""
          },
          {
            dimensionId:6,
            dimension: "媒体报道",
            dimensionScore: 20,
            dimensionWeight: 0,
            dimensionRuleExplain: ""
          }
        ]
      },
      options:{
        filter_rules: [
          ...filter_rules,
          {
            name: 'company',
            type: 'RichSearchInput',
            options: [],
            title: '公司选择',
            default: [],
            placeholder: '输入公司名称搜索内容',
            selectOne: true,
            input: '',
            pagination: { page:1, total:0, limit:10, offset:0 },
            style: { width: '200px' },
            loading: false,
          }
        ]
      },
      conditions: {
        company: []
      },
      builder:{
        /**
         * 增加自定义工具
         */
        'renderRichSearchInput': (vm,h,{ fieldset, values } = {})=>{ //必须加`render`前序
          return <RichSearchInput
            { ...{
             style: fieldset.style,
             props: {
              ...fieldset,
              value: values[fieldset.name] || fieldset.default,
              size: vm.$props.size
             },
             on: {
              'change': $event=>vm.onValueChanged($event, fieldset.name), //调用FilterBar对象内部函数
              'input': $event=>this.onInput($event),                      //调用当前页面对象的函数
              'pageChanged': $event=>this.onPageChanged($event)           //调用当前页面对象的函数
             }
            }}
          ></RichSearchInput>
        }
      }
    }
  },
  mounted () {
    this
      .refreshCompanys()
      .then((list)=>{
        const [first] = list;
        // this.conditions.company = [first]
        const rule = this.options.filter_rules.find(i=>i.name=='company')
        this.conditions.company = [first.id]
        rule.input = first.abbreviation
      })

    polling.debug = true
    polling.add('test', ()=>{
      this.$ivNotice.open({
        title: "测试提示",
        decs: "巴拉巴拉小魔仙，变！！！蠢",
        duration: 2000
      })
    }, 3000)
    polling.add('abc', ()=>{
      // notice.open({
      //   title: "测试提示",
      //   decs: "巴拉巴拉小魔仙，变！！！蠢",
      //   duration: 2000
      // })
    }, 1000)
    polling.onProcess(({logs})=>{
      this.logs = logs
    })
  },
  methods:{
    run(){
      polling.run()
    },
    stop(){
      polling.stop()
    },
    pause(id){
      polling.pause(id)
    },
    async refreshCompanys(params={}) {
      const rule = this.options.filter_rules.find(i=>i.name=='company')
      rule.loading = true
      const { limit, offset } = rule.pagination
      const res = await this.$$fetch(COMPANY, { ...params, offset, limit, type:"listed" });
      rule.pagination.total = res.total
      rule.loading = false
      return (rule.options = res.data.map(item => ({ id: item.stockCode, name: item.abbreviation, title:item.abbreviation, ...item })));
    },
    async onInput(query){
      const rule = this.options.filter_rules.find(i=>i.name=='company')
      rule.loading = true
      rule.input = query
      rule.pagination.page = 1
      rule.pagination.offset = 0
      await this.refreshCompanys({
        abbreviation: rule.input,
        ...rule.pagination
      })
      rule.loading = false
    },
    async onPageChanged({page}={}){
      const rule = this.options.filter_rules.find(i=>i.name=='company')
      rule.loading = true
      rule.pagination.page = page
      rule.pagination.offset = (page-1)*rule.pagination.limit
      this.refreshCompanys({
        abbreviation: rule.input,
        ...rule.pagination
      }).then(()=>rule.loading = false)
    }
  },
  computed: {
    companySetting(){
      const rule = this.options.filter_rules.find(i=>i.name=='company')
      return rule
    }
  },
  components: {
    EventsItem,
    ListedOpinionItem,
    FilterBar,
    PeriodSelector,
    DropdownSlider,
    // RichSearchInput
  }
}
</script>
